import React from 'react'
const getThumbnail = (thumbnailLink, mimeType, id) => {
    // if (thumbnailLink) {
    //     return `https://drive.google.com/thumbnail?id=${id}`
    // }
    return `https://drive-thirdparty.googleusercontent.com/128/type/${mimeType}`;
}
const Thumbnail = ({ mimeType, ...props }) => {
    // if(mimeType==="pdf"){
    return (
        <img
            src={getThumbnail(props.thumbnailLink, mimeType, props.fileId)}
            class="card-img-top img-fluid"
            alt={props.name}
        ></img>
    )
    // }
    // else if(mimeType==="ppt"){
    //     return(
    //         <img
    //         src="https://play-lh.googleusercontent.com/6pTX4OILXTxazqad66oiVfG4x2KpYn4kIPgdzOe173tT0oHr2ThwpBhMyzzzxWq_r6M"
    //         class="card-img-top"
    //         alt="..."
    //       ></img>
    //     )
    // }
    // else if(mimeType==="word"){
    //     return (
    //         <img
    //         src="https://play-lh.googleusercontent.com/9kABykeGovHPy-dN19lRxxnCp8IZK3Pkl8qLFNxrEe-hhKVZeiyhTBEIRUt6t-vhxQ"
    //         class="card-img-top"
    //         alt="..."
    //       ></img>
    //     )
    // }
    // else{
    //     return(
    //         <img
    //         src="https://www.mauchampions.com/wp-content/uploads/2017/04/default-image-620x600.jpg"
    //         class="card-img-top"
    //         alt="..."
    //       ></img>
    //     )

    // }
}

export default Thumbnail
